import { useEffect, useRef } from 'react';

const useTabVisibility = (onInactive, onActive) => {
  const onInactiveRef = useRef(onInactive);
  const onActiveRef = useRef(onActive);

  useEffect(() => {
    onInactiveRef.current = onInactive;
    onActiveRef.current = onActive;
  });

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        console.log('on incative');
        onInactiveRef.current?.();
      } else {
        console.log('Active');
        onActiveRef.current?.();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pagehide', handleVisibilityChange); // iOS safety net

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pagehide', handleVisibilityChange);
    };
  }, []); // stable listener, always reads latest callback
};

export default useTabVisibility;
